// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"826303f23cd6450a4e3e","293":"bc8dc3527ba39bb9d5c7","522":"943f2d20b1a629c67165"}[chunkId] + ".js";
};